import { ResourceManager } from './ResourceManager';
import { UpgradeManager } from './UpgradeManager';
import { CraftRecipe, CRAFT_RECIPES, getAvailableRecipes } from '../data/crafting';

// === GESTIONNAIRE DE CRAFT ===
// Valide et exécute les recettes de craft.
// Dépend du niveau de l'atelier (via UpgradeManager) et des ressources.

export class CraftingManager {
  private resources: ResourceManager;
  private upgrades: UpgradeManager;

  constructor(resources: ResourceManager, upgrades: UpgradeManager) {
    this.resources = resources;
    this.upgrades = upgrades;
  }

  /** Recettes disponibles selon le niveau d'atelier actuel */
  getAvailableRecipes(): CraftRecipe[] {
    const workshopLevel = this.upgrades.getBuildingLevel('workshop');
    return getAvailableRecipes(workshopLevel);
  }

  /** Vérifie si on peut crafter une recette (ressources + niveau atelier) */
  canCraft(recipeId: string): boolean {
    const recipe = CRAFT_RECIPES.find(r => r.id === recipeId);
    if (!recipe) return false;

    const workshopLevel = this.upgrades.getBuildingLevel('workshop');
    if (recipe.workshopLevel > workshopLevel) return false;

    return this.resources.canAfford(recipe.cost);
  }

  /**
   * Exécute un craft (dépense les ressources).
   * Retourne la recette craftée ou null en cas d'échec.
   */
  craft(recipeId: string): CraftRecipe | null {
    const recipe = CRAFT_RECIPES.find(r => r.id === recipeId);
    if (!recipe) return null;

    const workshopLevel = this.upgrades.getBuildingLevel('workshop');
    if (recipe.workshopLevel > workshopLevel) return null;

    if (!this.resources.spend(recipe.cost)) return null;

    return recipe;
  }
}
